export default "__VITE_ASSET__$$jSoiQT__"